console.log(null)
let _curpage = window.location.hash;

function showaccountpage(_curpage) {
  const pages = document.querySelectorAll('.account-pages');
  pages.forEach(page => {
    page.style.display = 'none';
  });

  switch (_curpage) {
    case '#orders':
      document.getElementById('ap-orders').style.display = 'block';
      break;
    case '#invoices':
      document.getElementById('ap-invoices').style.display = 'block';
      break;
    case '#billing':
      document.getElementById('ap-billing').style.display = 'block';
      break;
    case '#review':
      document.getElementById('ap-review').style.display = 'block';
      break;
    case '#downloads':
      document.getElementById('ap-download').style.display = 'block';
      break;
    default:
      document.getElementById('ap-account').style.display = 'block';
  }
}

showaccountpage(_curpage);

window.onhashchange = function() {
  const pages = document.querySelectorAll('.account-pages');
  pages.forEach(page => {
    page.style.display = 'none';
  });
  _curpage = window.location.hash;
  showaccountpage(_curpage);
}
